import {createBrowserRouter, Navigate, Outlet, useLocation} from 'react-router-dom';
import Layout from '../containers/layout';
import Login from '../containers/login';

import CmsApps from '../containers/Cms/Apps';
import CmsDataConnectors from '../containers/Cms/DataConnectors';
import CmsRevenue from '../containers/Cms/Revenue/index';
import CmsRevenueApp from '../containers/Cms/Revenue/rev_app';
import CmsCustomDashboard from '../containers/Cms/CustomDashboard';
import CmsAppMonetization from '../containers/Cms/Apps/monetization_backup'; // monetization
import CmsAppMonetizationReport from '../containers/Cms/Apps/monetization';
import CmsAppOverview from '../containers/Cms/Apps/overview';
import CmsAlerts from '../containers/Cms/Alerts/index';
import CmsAppTracking from '../containers/Cms/Apps/tracking';
import CmsSettingMenu from '../containers/Cms/Setting/menu';
import CmsSettingUsers from '../containers/Cms/Setting/User';
import CmsSettingUserPermissions from '../containers/Cms/Setting/User/permission';
import CmsSettingRoles from '../containers/Cms/Setting/Role';
import CmsSettingRolePermissions from '../containers/Cms/Setting/Role/permission';
import CmsSettingPermissions from '../containers/Cms/Setting/Permission';
import CmsSettingStudio from '../containers/Cms/Setting/Studio';
import CmsAppCampaignCenter from "../containers/Cms/Apps/campaign-center";
import AppCoHort from "../containers/Cms/Apps/cohort";
import CmsRevenueIAA from "../containers/Cms/Apps/revenue-iaa_backup"; // revenue-iaa
import CmsRevenueIAP from "../containers/Cms/Apps/revenue-iap_backup"; // revenue-iap
import CmsRevenueIAAReport from "../containers/Cms/Apps/revenue-iaa";
import CmsDashboard from "../containers/Cms/Dashboard/index";

import StudioApps from '../containers/Studio/Apps';
import StudioAppMonetization from '../containers/Studio/Apps/monetization';
import StudioAppOverview from '../containers/Studio/Apps/overview';
import StudioAppTracking from '../containers/Studio/Apps/tracking';
import StudioAppCampaignCenter from "../containers/Studio/Apps/campaign-center";
import StudioRevenueIAA from "../containers/Studio/Apps/revenue-iaa";
import StudioUser from "../containers/Studio/User";
import CreativeCenter from "../containers/Cms/Apps/creative-center";
import LevelAnalytics from "../containers/Cms/LevelAnalytics";
import FireBase from "../containers/Cms/Apps/ABTesting/firebase";
import Mediation from "../containers/Cms/Apps/ABTesting/mediation";
import Prediction from "../containers/Cms/Apps/prediction";

import ProtectedRoute from '../components/ProtectedRoute';
import ResourceAnalyticsApp from '../containers/Cms/ResourceAnalytics';
import ErrorPage from '../components/ErrorPage';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';
import ReleaseIntel from '../containers/Cms/ReleaseIntel';
import StudioUserPermission from '../containers/Studio/User/permission';

// Create a wrapper component for root routes to handle studio redirect
const RootRoutesWrapper = () => {
  const { userInfo, isLoading } = useAuth();
  const location = useLocation();
  const auth = userInfo || null;
  const studio = auth?.studio;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (studio && (location.pathname === '/' || location.pathname === '')) {
    return <Navigate to={`/organisations/${studio}/apps`} replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

// Create a wrapper component for studio routes
const StudioRoutesWrapper = () => {
  const { userInfo, isLoading } = useAuth();
  const location = useLocation();
  const auth = userInfo || null;
  const studio = auth?.studio;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!studio) {
    return <Navigate to="/" replace />;
  }

  if (location.pathname === `/organisations/${studio}`) {
    return <Navigate to={`/organisations/${studio}/apps`} replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

const AppRoutes = [
	{
		path: '/',
		element : <RootRoutesWrapper />,
		errorElement: <ErrorPage />,
		children : [
			{
				title : 'BI Global - Apps',
				path: '/',
				element : <ProtectedRoute><CmsApps /></ProtectedRoute>
			},
			{
				title : 'BI Global - Data Connectors',
				path: 'apps/:code/:os/data_connectors',
				element : <ProtectedRoute><CmsDataConnectors /></ProtectedRoute>
			},
			{
				title : 'BI Global - Revenue',
				path: 'revenue',
				element : <ProtectedRoute><CmsRevenue /></ProtectedRoute>
			},
			{
				title : 'BI Global - Apps',
				path: 'apps',
				element : <ProtectedRoute><CmsApps /></ProtectedRoute>
			},
			{
				title : 'Monetization Report',
				path: 'monetization-report',
				element : <ProtectedRoute><CmsAppMonetizationReport /></ProtectedRoute>
			},
			{
				title : ':name :os overview',
				path: 'apps/:code/:os/overview',
				element : <ProtectedRoute><CmsAppOverview /></ProtectedRoute>		
			},
			{
				title : ':name :os monetization-overview',
				path: 'apps/:code/:os/monetization-overview',
				element : <ProtectedRoute><CmsAppMonetization /></ProtectedRoute>
			},
			{
				title : ':name :os monetization-report',
				path: 'apps/:code/:os/monetization-report',
				element : <ProtectedRoute><CmsAppMonetizationReport /></ProtectedRoute>
			},
			{
				title : ':name :os campaign-center',
				path: 'apps/:code/:os/campaign-center',
				element : <ProtectedRoute><CmsAppCampaignCenter /></ProtectedRoute>
			},
			{
				title : ':name :os level-analytics',
				path: 'apps/:code/:os/level-analytics',
				element : <ProtectedRoute><LevelAnalytics /></ProtectedRoute>
			},
			{
				title : ':name :os resource-analytics',
				path: 'apps/:code/:os/resource-analytics',
				element : <ProtectedRoute><ResourceAnalyticsApp /></ProtectedRoute>
			},
			{
				title : ':name :os firebase',
				path: 'apps/:code/:os/firebase',
				element : <ProtectedRoute><FireBase /></ProtectedRoute>
			},
			{
				title : ':name :os mediation',
				path: 'apps/:code/:os/mediation',
				element : <ProtectedRoute><Mediation /></ProtectedRoute>
			},
			{
				title : ':name :os prediction',
				path: 'apps/:code/:os/prediction',
				element : <ProtectedRoute><Prediction /></ProtectedRoute>
			},
			{
				title : ':name :os release-intel',
				path: 'apps/:code/:os/release-intel',
				element : <ProtectedRoute><ReleaseIntel /></ProtectedRoute>
			},
			{
				title : ':name :os Cohort',
				path: 'apps/:code/:os/cohort',
				element : <ProtectedRoute><AppCoHort /></ProtectedRoute>
			},
			{
				title : ':name :os creative-center',
				path: 'apps/:code/:os/creative-center',
				element : <ProtectedRoute><CreativeCenter /></ProtectedRoute>
			},
			{
				title : ':name :os revenue-iaa',
				path: 'apps/:code/:os/revenue-iaa',
				element : <ProtectedRoute><CmsRevenueIAA /></ProtectedRoute>
			},
			{
				title : ':name :os revenue-iap',
				path: 'apps/:code/:os/revenue-iap',
				element : <ProtectedRoute><CmsRevenueIAP /></ProtectedRoute>
			},
			{
				title : ':name :os revenue-iaa-report',
				path: 'apps/:code/:os/revenue-iaa-report',
				element : <ProtectedRoute><CmsRevenueIAAReport /></ProtectedRoute>
			},
			{
				title : ':name :os tracking',
				path: 'apps/:code/:os/tracking',
				element : <ProtectedRoute><CmsAppTracking /></ProtectedRoute>
			},
			{
				title : 'BI Global - Custom View',
				path: 'custom_view',
				element : <ProtectedRoute><CmsCustomDashboard /></ProtectedRoute>
			},
			{
				title : 'BI Global - Revenue Apps',
				path: 'revenue_apps',
				element : <ProtectedRoute><CmsRevenueApp /></ProtectedRoute>
			},
			{
				title : 'BI Global - Alert',
				path: 'alerts',
				element : <ProtectedRoute><CmsAlerts /></ProtectedRoute>
			},{
				title : 'BI Global - Menu',
				path: 'setting/menu',
				element : <ProtectedRoute><CmsSettingMenu /></ProtectedRoute>
			},{
				title : 'BI Global - User',
				path: 'setting/users',
				element : <ProtectedRoute><CmsSettingUsers /></ProtectedRoute>
			},{
				title : 'BI Global - User',
				path: 'setting/users/:user/permissions',
				element : <ProtectedRoute><CmsSettingUserPermissions /></ProtectedRoute>
			},{
				title : 'BI Global - Role',
				path: 'setting/roles',
				element : <ProtectedRoute><CmsSettingRoles /></ProtectedRoute>
			},{
				title : 'BI Global - User',
				path: 'setting/roles/:role/permissions',
				element : <ProtectedRoute><CmsSettingRolePermissions /></ProtectedRoute>
			},{
				title : 'BI Global - Permission',
				path: 'setting/permissions',
				element : <ProtectedRoute><CmsSettingPermissions /></ProtectedRoute>
			},{
				title : 'BI Global - Studio',
				path: 'setting/studio',
				element : <ProtectedRoute><CmsSettingStudio /></ProtectedRoute>
			},{
				title : 'Not Found',
				path: '*',
				element : <ProtectedRoute><ErrorPage /></ProtectedRoute>
			},
			{
				title : 'BI Global - Dashboard',
				path: 'dashboard',
				element : <ProtectedRoute><CmsDashboard /></ProtectedRoute>
			}
		]
	},
	{
		path: '/organisations',
		element: <ProtectedRoute><ErrorPage /></ProtectedRoute>
	},
	{
		path: '/login',
		element: <Login />
	},
		{
			path: '/organisations/:studio',
			element: <StudioRoutesWrapper />,
			errorElement: <ErrorPage />,
			children: [
			{
				title: 'Studio Apps',
				path: '',
				element: <ProtectedRoute><StudioApps /></ProtectedRoute>
			},
			{
				title: 'Studio Apps',
				path: 'apps',
				element: <ProtectedRoute><StudioApps /></ProtectedRoute>
			},
			{
				title: 'Studio :name :os overview',
				path: 'apps/:code/:os/overview',
				element: <ProtectedRoute><StudioAppOverview /></ProtectedRoute>
			},
			{
				title: 'Studio :name :os monetization-overview',
				path: 'apps/:code/:os/monetization-overview',
				element: <ProtectedRoute><StudioAppMonetization /></ProtectedRoute>
			},
			{
				title : 'Studio Monetization Report',
				path: 'monetization-report',
				element : <ProtectedRoute><CmsAppMonetizationReport /></ProtectedRoute>
			},
			{
				title : 'Studio :name :os monetization-report',
				path: 'apps/:code/:os/monetization-report',
				element : <ProtectedRoute><CmsAppMonetizationReport /></ProtectedRoute>
			},
			{
				title: 'Studio :name :os tracking',
				path: 'apps/:code/:os/tracking',
				element: <ProtectedRoute><StudioAppTracking /></ProtectedRoute>
			},
			{
				title: 'Studio :name :os campaign-center',
				path: 'apps/:code/:os/campaign-center',
				element: <ProtectedRoute><CmsAppCampaignCenter /></ProtectedRoute>
			},
			{
				title: 'Studio :name :os Cohort',
				path: 'apps/:code/:os/cohort',
				element: <ProtectedRoute><AppCoHort /></ProtectedRoute>
			},
			{
				title: 'Studio :name :os creative-center',
				path: 'apps/:code/:os/creative-center',
				element: <ProtectedRoute><CreativeCenter /></ProtectedRoute>
			},
			{
				title: 'Studio :name :os revenue-iaa',
				path: 'apps/:code/:os/revenue-iaa',
				element: <ProtectedRoute><StudioRevenueIAA /></ProtectedRoute>
			},
			{
				title : 'Studio :name :os revenue-iap',
				path: 'apps/:code/:os/revenue-iap',
				element : <ProtectedRoute><CmsRevenueIAP /></ProtectedRoute>
			},
			{
				title: 'Studio - Custom View',
				path: 'custom_view',
				element: <ProtectedRoute><CmsCustomDashboard /></ProtectedRoute>
			},
			{
				title: 'Studio - Revenue Apps',
				path: 'revenue_apps',
				element: <ProtectedRoute><CmsRevenueApp /></ProtectedRoute>
			},
			{
				title: 'Studio - Dashboard',
				path: 'dashboard',
				element: <ProtectedRoute><CmsDashboard /></ProtectedRoute>
			},
			{
				title: 'Studio - User Management',
				path: 'users',
				element: <ProtectedRoute><StudioUser /></ProtectedRoute>
			},
			{
				title: 'Studio - User Permission',
				path: 'user/:userId/permission',
				element: <ProtectedRoute><StudioUserPermission /></ProtectedRoute>
			},

			{
				path: '*',
				element: <ProtectedRoute><ErrorPage /></ProtectedRoute>
			}
		]
	}
];

const routes = createBrowserRouter(AppRoutes);
export default routes;